import { FunctionComponent, useCallback } from "react";
import "./Header.scss";
import { useNavigate } from "react-router-dom";
import images from "../../assets/images";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { logout } from "../../redux/slices/authSlice";


const Header: FunctionComponent = () => {
  const navigate = useNavigate();
  const {katonHeaderLogo} = images;
  const dispatch = useAppDispatch();
  const { isKaton } = useAppSelector((state) => state.auth);
    
  // navigate to landing page while click header logo
  const onHeaderLogoImageClick = useCallback(() => {
    navigate("/");
    dispatch(logout());
  }, [isKaton]);

  return (
    <section className="sectionHeader">
      <div className="headercontainer">
        <img
          className={`hdrLogoIcon`}
          alt="logoImage"
          src={katonHeaderLogo}
          onClick={onHeaderLogoImageClick}
          
        />
      </div>
    </section>
  );
};

export default Header;
